import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSupplementaryPlan } from '@simplywallst/services';
import { useSnackbar } from '@/features/snackbar';
import { withAuth } from '@/utilities/queries';
import { queryKey as authInfoQueryKey } from '@/hooks/useAuthInfo';
import { QUERY_KEY as userQueryKey } from '@/hooks/useUser';

export function useProApiRegistration() {
  const queryClient = useQueryClient();
  const { addSnackbar } = useSnackbar();
  const { mutate, status } = useMutation({
    mutationFn: async () => {
      await withAuth(createSupplementaryPlan, { plan_type: 'pro-api' });
    },
    onSuccess() {
      addSnackbar({
        id: 'pro-api-success',
        message: 'Registration successful',
        type: 'positive',
        actionLabel: 'OK',
      });
    },
    onSettled() {
      queryClient.invalidateQueries({ queryKey: authInfoQueryKey });
      queryClient.invalidateQueries({ queryKey: userQueryKey });
    },
  });
  return { status, mutate };
}
